import { ReactNode, useState } from "react";
import styles from "./MCarousel.module.css";

interface MCarouselProps {
  children: ReactNode[];
  currentIndex: number;
  onIndexChange?: (index: number) => void;
  variant?: "default" | "actionCard";
}

const MCarousel = ({
  children,
  currentIndex,
  onIndexChange,
  variant = "default",
}: MCarouselProps) => {
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const minSwipeDistance = 50;

  const onTouchStart = (e: React.TouchEvent) => {
    setTouchEnd(0);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe && currentIndex < children.length - 1) {
      onIndexChange?.(currentIndex + 1);
    }
    if (isRightSwipe && currentIndex > 0) {
      onIndexChange?.(currentIndex - 1);
    }
  };

  return (
    <div
      className={`${styles.carousel} ${
        variant === "actionCard" ? styles.actionCardVariant : ""
      }`}
    >
      <div className={styles.indicators}>
        {children.map((_, index) => (
          <button
            key={`carousel-indicator-${index}`}
            className={`${styles.indicator} ${
              index === currentIndex ? styles.active : ""
            }`}
            onClick={() => onIndexChange?.(index)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onIndexChange?.(index);
              }
            }}
            aria-label={`Go to slide ${index + 1}`}
            aria-current={index === currentIndex}
            type="button"
          />
        ))}
      </div>

      <div
        className={styles.slides}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {children.map((child, index) => (
          <div
            key={`carousel-slide-${index}`}
            className={`${styles.slide} ${
              index === currentIndex ? styles.activeSlide : ""
            }`}
          >
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MCarousel;
